import { useEffect, useState, useRef } from "react"
import { useNavigate } from 'react-router-dom'
import { useGetHepExercisesQuery, useUpdateSortExercisesMutation } from "./hepexercisesApiSlice"
import HepExercise from "./HepExercise"
import PulseLoader from 'react-spinners/PulseLoader'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileCirclePlus } from "@fortawesome/free-solid-svg-icons"
import {isMobileDevice} from "../../config/functions"


const HepExerciseList = ({ hep_id, program}) => {

    const navigate = useNavigate()
    const isMobile = isMobileDevice()

    const [exercises, setExercises] = useState([])

    const {
        data: hepExercises,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetHepExercisesQuery('hepexercisesList', { refetchOnMountOrArgChange: true })

    let content

    if (isLoading) content = <PulseLoader color={"#5f788a"} />

    useEffect(() => {

        if (isError) {
            toast.error(error?.data?.message);
        }
        if (isSuccess) {
            const {ids, entities} = hepExercises
            const filteredIds = ids.filter(hepId => entities[hepId].hep_id === hep_id)
            setExercises(filteredIds)
        }

    }, [isError, error, hepExercises,hep_id, isSuccess])

    const onNewHepExerciseClicked = () => navigate(`/dash/hep/exercises/new/${hep_id}`)


    // sorting with drag and drop

    const [sortExercises, {
        data: sort,
        isSuccess: isSuccessSort,
        isError: isErrorSort
    }] =  useUpdateSortExercisesMutation()


    useEffect(() => {

        if (isErrorSort) {
             toast.error(sort?.error);
        }
        if (isSuccessSort) {
            console.log(sort?.message);
        }
        
    }, [isErrorSort, isSuccessSort, sort])
    

    const onSort = async (data) => {
        await sortExercises({ exercises: data })
    }


    const dragItem = useRef()
    const dragOverItem = useRef()

    const dragStart = (e) => {
        dragItem.current = e.target.id
    }
    const dragEnter = (e) => {
        dragOverItem.current = e.currentTarget.id
    }
    const drop = () => {
        const copyExercises = [...exercises]
        const dragItemContent = copyExercises[dragItem.current]
        copyExercises.splice(dragItem.current, 1)
        copyExercises.splice(dragOverItem.current, 0, dragItemContent)
        dragItem.current = null
        dragOverItem.current = null
        setExercises(copyExercises)
        onSort(copyExercises)
    } 




    if (isSuccess) {

        const tableContent = exercises?.length && exercises.map((hepId, index) => <HepExercise 
            key={hepId} hepId={hepId} isMobile={isMobile}  index={index} 
            dragStart={dragStart} dragEnter={dragEnter} drop={drop}
            />)

    

        if (exercises?.length) {
            content = (
                <>
                <div className="row mt-3">
                    <div className="col-md-10">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Exercises for HEP #{program}</th>
                                    {isMobile === false && <th>Details</th>}
                                    <th>Edit</th>
                                </tr>
                            </thead>
                            <tbody style={{cursor: "move"}}>
                                {tableContent}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-10 text-end">
                        <span
                            role="button"
                            className="text-info p-3 icon"
                            title="Add Exercise"
                            onClick={onNewHepExerciseClicked}
                        >
                            Add Exercise
                            <FontAwesomeIcon icon={faFileCirclePlus}  className="fa-icon"/>
                        </span>
                    </div>
                </div>
                </>
            )
    
        } else {
            content = (
                <>
                <div className="row mt-3">
                    <div className="col-md-10">
                        <span
                            role="button"
                            className="text-info p-3 icon"
                            title="Add Exercise"
                            onClick={onNewHepExerciseClicked}
                        >
                            Add Exercise
                            <FontAwesomeIcon icon={faFileCirclePlus}  className="fa-icon"/>
                        </span>
                    </div>
                </div>
                </>
            )
    
        }
    }

    return content
}
export default HepExerciseList